import React from 'react';
import {Link} from 'react-router-dom'
import './Navbar.css';

function Navbar() {
  return (
    <nav className='navbar'>
      <Link to={'pers_projects/transport_service/'}>
        <img src='https://uploads-ssl.webflow.com/63357010a5a26f4ec951d0e2/6336a976879cf733cb0c761f_Frame.svg' alt='Padam Mobility'/>
      </Link>
      <div className='navbar-links-container'>
        <Link to={'pers_projects/transport_service/book_ride'}>Book a ride</Link>
        <Link to={'pers_projects/transport_service/about'}>About</Link>
      </div>
    </nav>
  )
}

export default Navbar
